'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const edgeConfig = {
  basePath: "/api/.ory",
  baseOptions: {
    withCredentials: true
  }
};

exports.edgeConfig = edgeConfig;
//# sourceMappingURL=index.js.map
